$(document).ready(function () {

    const MAX_SEARCHES_PER_HOUR = 5;
    const TRACKING_KEY = 'sky_tracking_limits';

    
    // Checks if the unique search limit has been hit and updates the tracking log.
    function checkAndUpdateLimit(trackingId) {
        const now = Date.now();
        const oneHour = 15 * (60 * 1000); // 30 minutes
        const oneHourAgo = now - oneHour; 

        // 1. Get existing data: { '123456': timestamp, '789012': timestamp, ... }
        let limits = JSON.parse(localStorage.getItem(TRACKING_KEY)) || {};

        // 2. Cleanup: Remove expired and non-unique searches
        // We maintain a map of {trackingId: timestamp} to track uniqueness and recency.
        let uniqueCount = 0;
        
        // Create a new map for cleaned, recent entries
        const newLimits = {};

        for (const [key, timestamp] of Object.entries(limits)) {
            if (timestamp > oneHourAgo) {
                newLimits[key] = timestamp;
                uniqueCount++;
            }
        }
        limits = newLimits; // Update the list to only contain recent, unique IDs

        // 3. Check if the current trackingId already exists (repeated search)
        if (limits.hasOwnProperty(trackingId)) {
            // Repeated search for the same unique ID within the hour, just update timestamp
            limits[trackingId] = now; 
            localStorage.setItem(TRACKING_KEY, JSON.stringify(limits));
            return true; // Allowed
        }

        // 4. Check if the unique count limit is exceeded for a NEW ID
        if (uniqueCount >= MAX_SEARCHES_PER_HOUR) {
            // Cannot add a new unique ID
            localStorage.setItem(TRACKING_KEY, JSON.stringify(limits));
            return false; // Limit exceeded
        }

        // 5. Record the NEW search time and save
        limits[trackingId] = now;
        localStorage.setItem(TRACKING_KEY, JSON.stringify(limits));
        //console.log('TK',localStorage.getItem(TRACKING_KEY));
        return true; // Search allowed
    }

    function performTracking() {
        const inputValue = $('#trackingInput').val().trim();
        // Note: trackingType select is no longer in the HTML, so we rely on regex
        let apiUrl = '';

        // Check the rate limit first
        if (!checkAndUpdateLimit(inputValue)) {
            $('#initialMessage').removeClass('hiddenDiv').html('<div class="text-red-600 font-semibold">You have exceeded the search limit. Please try again later.</div>');
            $('#trackResultContainer').addClass('hiddenDiv');
            return;
        }

        if (inputValue === '') {
            $('#initialMessage').removeClass('hiddenDiv').html('<div class="text-red-600 font-semibold">Please enter an Order Number or AWB.</div>');
            $('#trackResultContainer').addClass('hiddenDiv');
            return;
        }

        // Automatic detection logic (copied from original JS)
        const isOrderNumber = /^\d{6,7}$/.test(inputValue);
        const finalTrackingType = (isOrderNumber ? 'order' : 'awb');

        if (finalTrackingType === 'order') {
            apiUrl = `https://sonifashion.shiprocket.co/tracking/order/${inputValue}`;
        } else { // awb
            apiUrl = `https://sonifashion.shiprocket.co/tracking/${inputValue}`;
        }

        $('#loadingSpinner').show();
        $('#initialMessage').addClass('hiddenDiv');
        $('#trackResultContainer').addClass('hiddenDiv'); // Hide container while loading

        $.ajax({
            url: apiUrl,
            method: 'GET',
            success: function (data) {
                updateDomWithData(data, {
                    trackingType: finalTrackingType,
                    inputValue: inputValue
                });
            },
            error: function (xhr, status, error) {
                $('#trackResultContainer').addClass('hiddenDiv');
                $('#initialMessage').removeClass('hiddenDiv').html('<p class="text-red-600 font-semibold">Error fetching tracking information.<br/>Please ensure the Order ID/AWB is correct and try again later.</p>');
                console.error("AJAX Error:", status, error);
            },
            complete: function () {
                $('#loadingSpinner').hide();
            }
        });
    }

    function updateStatus(statusText) {
        const statusP = $('#displayStatus');
        statusP.html(statusText).removeClass('status-rto status-delivered').find('svg').remove();

        const statusTextLower = statusText.toLowerCase();

        // 1. Check for Cancellation status
        if (statusTextLower.includes('cancelled') || statusTextLower.includes('cancel')) {
            // Hide the Map and Timeline sections for cancelled orders
            $('#trackingTimelineSection').addClass('hiddenDiv');
            $('#mapSection').addClass('hiddenDiv');
        } else {
            // Ensure they are visible for all other statuses
            $('#trackingTimelineSection').removeClass('hiddenDiv');
            $('#mapSection').removeClass('hiddenDiv');
        }
        
        const statusIcons = {
            rto: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="svgIco">
                    <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75ZM12 15a.75.75 0 0 0-.75.75.75.75 0 0 0 1.5 0 .75.75 0 0 0-.75-.75Z" clip-rule="evenodd" />
                    </svg>`,
            delivered: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="svgIco">
                            <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
                        </svg>`
        };

        if (statusTextLower.includes('rto')) {
            statusP.addClass('status-rto').prepend(statusIcons.rto);
        } else if (statusTextLower.includes('delivered')) {
            statusP.addClass('status-delivered').prepend(statusIcons.delivered);
        } else if (statusTextLower.includes('cancel')) {
            statusP.addClass('status-cancel').prepend(statusIcons.rto);
        }
        
    }

    function updateDomWithData(htmlData, context) {
        // 1. Check for success block using a simple string search
        if (!htmlData.includes('information_block')) {
            $('#initialMessage').removeClass('hiddenDiv').html('<p class="text-red-600 font-semibold">Tracking information not found. Please check the number and try again.</p>');
            return;
        }

        // 2. Safely parse the HTML string into a temporary, isolated DOM object
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlData, 'text/html');
        const informationBlock = $(doc).find('.information_block'); // Use jQuery for easy querying on the parsed doc

        // Guard Clause (redundant check, but safe)
        if (!informationBlock.length) {
            $('#initialMessage').removeClass('hiddenDiv').html('<p class="text-red-600 font-semibold">Tracking information not found. Please check the number and try again.</p>');
            return;
        }

        $('#trackResultContainer').removeClass('hiddenDiv');

        // --- Extract Data using DOM methods and RegEx ---

        // A. Order Details using RegEx on the whole response text for efficiency
        const orderDetailsText = informationBlock.text();
        const orderId = (orderDetailsText.match(/Order ID\s*(\d+)/) || [])[1] || 'N/A';
        const orderPlacedOn = (orderDetailsText.match(/Order Placed On\s*(\d{2}\s\w{3}\s\d{4})/) || [])[1] || 'N/A';
        
        // B. Status and Courier using the parsed DOM object
        const statusText = $(doc).find('#shipment_status').text().trim() || 'Unknown Status';
        const courierInfo = $(doc).find('.courier_info b').first().text().trim() || 'N/A';

        // C. Tracking ID logic (remains the same)
        let trackingId = $(doc).find('.tracking_id').text().trim();
        if (!trackingId) {
            trackingId = context.trackingType === 'awb' ? context.inputValue : 'N/A';
        }

        // --- Update DOM ---
        $('#displayOrderId').text(orderId);
        $('#displayOrderPlacedOn').text(orderPlacedOn);
        $('#displayTrackingId').text(trackingId);
        $('#displayCourierName').text(courierInfo);

        updateStatus(statusText);
        
        // Pass the parsed document object to buildTimeline
        buildTimeline(doc);

        // --- Extract Map ---
        const mapData = $(doc).find('.map-container').html();
        $('.map-placeholder').html(mapData || '<p>Map not available.</p>');
    }

    function buildTimeline(doc) { 
        const timelineContent = $('#timelineContent').empty();
        
        // Find activities using the parsed DOM object
        const trackingActivities = $(doc).find('.delievery_list_wrap ul li'); 

        if (trackingActivities.length > 0) {
            trackingActivities.each(function () {
                
                const date = $(this).find('.date').text().trim();
                const time = $(this).find('.time').text().trim();
                const activity = $(this).find('activity').eq(0).text().trim();
                const location = $(this).find('activity').eq(1).text().trim();
                
                const timelineItem = $('<div>', {
                    class: 'timeline-item'
                }).append(
                    $('<div>', {
                        class: 'timeline-item-point'
                    }),
                    $('<div>', {
                        class: 'timeline-date-time',
                        text: `${date} ${time}`
                    }),
                    $('<div>', {
                        class: 'timeline-activity',
                        text: activity
                    }),
                    $('<div>', {
                        class: 'timeline-location',
                        text: location ? `Location: ${location}` : ''
                    })
                );

                // Add highlight classes
                const activityTextLower = activity.toLowerCase();
                if (activityTextLower.includes('picked up')) {
                    timelineItem.addClass('highlight-picked-up');
                } else if (
                    /out for delivery/.test(activityTextLower)
                ) {
                    timelineItem.addClass('highlight-out-for-delivery');
                } else if (
                    /not delivered|address incomplete|cant deliver|undelivered|unable to deliver|consignee unavailable/.test(activityTextLower)
                ) {
                    timelineItem.addClass('highlight-not-delivered');
                }

                timelineContent.append(timelineItem);
            });
        } else {
            timelineContent.html('<p class="text-gray-500 text-sm">No detailed activities found.</p>');
        }
    }

    // Event listener for the track button click
    $('#trackButton').on('click', performTracking);

    // Allow pressing Enter to track
    $('#trackingInput').on('keypress', function (e) {
        if (e.which === 13) { // Enter key
            performTracking();
        }
    });

    // Check for URL parameters on page load
    const urlParams = new URLSearchParams(window.location.search);
    const paramType = urlParams.get('type'); // Retained for logic clarity, though input type is auto-detected
    const paramTracking = urlParams.get('track');

    if (paramTracking) {
        // Set values from URL parameters
        $('#trackingInput').val(paramTracking);
        // Trigger the click event to load results
        performTracking();
    }
});